<template>
  <!-- App Header -->
  <SideHeader :indexPage="true" />

  <!-- * App Header -->

  <!-- Extra Header -->
  <div class="extraHeader">
    <ul class="nav nav-tabs lined" role="tablist">
      <li class="nav-item">
        <a class="nav-link active" data-bs-toggle="tab" href="#ticket" role="tab">
          تیکت
        </a>
      </li>
      <li class="nav-item">
        <a @click="getMessages(postData.mobileNumber)" class="nav-link" data-bs-toggle="tab" href="#archive" role="tab">
          بایگانی
        </a>
      </li>
    </ul>
  </div>
  <!-- * Extra Header -->

  <!-- App Capsule -->
  <div style="padding-top: 55px;" class="extra-header-active">

    <div class="tab-content mt-1">
      <!-- ticket tab -->
      <div class="tab-pane fade show active" id="ticket" role="tabpanel">

        <div class="section full mt-1">
          <div class="section-title">تیکت پشتیبانی</div>

          <div class="wide-block pt-2 pb-2">

            <div class="tab-content mt-2">
              <form>
                <div class="form-group basic">
                  <div class="input-wrapper">
                    <label class="form-label" for="title">عنوان</label>
                    <input type="text" class="form-control" name="title" id="title" v-model="postData.title" />
                  </div>
                </div>
                <div class="form-group basic">
                  <div class="input-wrapper">
                    <label class="form-label" for="description">توضیحات</label>
                    <textarea id="description" name="description" rows="2" class="form-control"
                      v-model="postData.message"></textarea>
                    <i class="clear-input">
                      <ion-icon name="close-circle" role="img" class="md hydrated" aria-label="close circle"></ion-icon>
                    </i>
                  </div>
                </div>
                <div class="mt-2">
                  <button class="btn background-ORANGE text-light btn-block btn-block" @click.prevent="createPost"
                    type="submit">
                    ارسال
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <!-- * ticket tab -->



      <!-- archive tab -->
      <div class="tab-pane fade" id="archive" role="tabpanel">

        <div class="section full mt-1">
          <div class="section-title">پیام های بایگانی شده</div>
          <div class="wide-block pb-2">
            <div class="tab-content mt-2">
              <div class="tab-pane fade show active" role="tabpanel">
                <Placeholder v-if="loading" />
                <div v-else v-for="(item, index) in messages" :key="index" class="section"
                  :class="{ 'section my-4': index !== 0, 'mt-5': index == 0 }">
                  <div class="card " v-if="messages != ''">
                    <div class="card-header bg-header">
                      <div class="d-flex justify-content-between">
                        <span style="font-size: 13px;">شماره تیکت : {{ item.id }}</span>
                        <span style="font-size: 13px; direction: ltr;">{{ item.messageDateAndTime }}</span>
                      </div>
                    </div>
                    <div class="card-body p-2">
                      <div class="card-text">
                        <p class="fw-bold">{{ item.title }}</p>
                        <p>{{ item.message }}</p>
                        <p class="text-end">
                          <button class="btn background-ORANGE text-light btn-sm" data-bs-toggle="offcanvas"
                            data-bs-target="#actionSheetForm">پاسخ
                          </button>
                        </p>

                        <!-- Form Action Sheet -->
                        <div class="offcanvas offcanvas-bottom action-sheet" tabindex="-1" id="actionSheetForm">
                          <div class="offcanvas-header">
                            <h5 class="offcanvas-title">پاسخ</h5>
                          </div>
                          <div class="offcanvas-body">
                            <div class="action-sheet-content">

                              <form @submit.prevent="handleResultMessage(item.id)">
                                <div class="form-group basic">
                                  <div class="input-wrapper">
                                    <label class="form-label" for="result">پیام</label>
                                    <textarea id="result" name="result" rows="2" class="form-control"
                                      v-model="postResult.result"></textarea>
                                  </div>
                                </div>
                                <div class="form-group basic">
                                  <button type="submit" class="btn background-ORANGE text-light btn-block"
                                    data-bs-dismiss="offcanvas">ثبت</button>
                                </div>
                              </form>

                            </div>
                          </div>
                        </div>
                        <!-- * Form Action Sheet -->
                        <div v-if="item.children_recursive.lenght !== 0">
                          <div v-for="(children, index) in item.children_recursive" :key="index">
                            <hr>
                            <div class="d-flex justify-content-between">
                              <span class="text-success">پیام
                                <span :class="{ 'text-MINT': children.role == 'operator', 'text-success': children.role == 'driver' }">
                                  {{ children.role == 'operator' ? 'کارشناس' : 'راننده' }}
                                </span>

                              </span>
                              <span style="font-size: 13px; direction: ltr;">{{ children.shamsiUpdatedDate }}</span>
                            </div>
                            <div class="mt-2">
                              <p>{{ children.result }}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <p class="text-center" v-if="messages == ''">پیام یافت نشد</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- * archive tab -->
    </div>
  </div>
  <!-- * App Capsule -->
</template>

<script>
import axios from "axios";
import delivery_methods from "@/delivery_methods";
import Swal from "sweetalert2";
import Placeholder from "@/components/Placeholder.vue";
import SideHeader from "@/components/SideHeader.vue";
// import Swal from "sweetalert2";
export default {
  name: "Support",
  data() {
    return {
      postResult: {
        result: "",
      },
      postData: {
        role: "driver",
        name: "",
        lastName: "",
        message: "",
        mobileNumber: "",
        email: "driver.gmail.com",
      },
      loading: false,
      foundObject: null,
      messages: [],
      axiosConfig: {
        headers: {
          'Authorization': `Bearer ${window.localStorage.getItem("token")}`,
          'Accept': 'application/json'
        }
      }
    };
  },
  methods: {
    handleResultMessage(itemId) {
      axios.post(`https://core.iran-tarabar.ir/api/driver/changeMessageStatus/${itemId}`, this.postResult, this.axiosConfig)
        .then((response) => {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "پیام شما با موفقیت ثبت شد",
            showConfirmButton: false,
            timer: 2000
          });

          this.findObjectById(itemId);
          if (this.foundObject) {
            this.foundObject.children_recursive.push(response.data);
          }
        });
    },
    findObjectById(itemId) {
      this.foundObject = this.messages.find(item => item.id === itemId);
    },
    getProfileInfo() {
      axios
        .get(`${delivery_methods.BASE_URL}api/driver/getDriverProfileInfo`, this.axiosConfig)
        .then((response) => {
          this.postData.name = response.data.data.name;
          this.postData.lastName = response.data.data.lastName;
          this.postData.mobileNumber = response.data.data.mobileNumber;
          // this.getMessages(this.postData.mobileNumber);
        })
        .catch(function (res) {
          // handle error
          console.log(res);
        });
    },
    getMessages(mobileNumber) {
      this.loading = true
      axios.get(`${delivery_methods.BASE_URL}api/driver/driverMessages/${mobileNumber}`, this.axiosConfig)
        .then((response) => {
          console.log(response.data);
          this.messages = response.data;
        })
        .catch(function (res) {
          // handle error 
          // console.log(res);
        })
        .finally((res) => {
          this.loading = false
        });
    },
    createPost() {
      axios.post(`https://core.iran-tarabar.ir/api/driver/sendMessage`, this.postData, this.axiosConfig)
        .then((response) => {
          if (response.data.result == 1) {
            Swal.fire({
              title: `با تشکر از شما`,
              text: "پیام شما برای تیم پشتیبانی ارسال شد!",
              icon: "success",
              showCancelButton: false,
              confirmButtonColor: "#3085d6",
              confirmButtonText: "حله",
            }).then((result) => {
              if (result.isConfirmed) {
                location.reload();
              }
            });
          }
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        });
    },
  },
  beforeMount() {
    this.getProfileInfo();
  },
  mounted() {
    // this.getMessages();
  },
  components: { Placeholder, SideHeader }
};
</script>

<style scoped>
.bg-header {
  background-color: #e1e1e14a;
}
</style>